import React from "react";
import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src="https://i.ibb.co/nMBHDCBp/photo-2026-01-06-22-58-52.jpg" alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://t.me/CRYPTOGCALL" target="_blank" rel="noreferrer"><TwitterIcon/></a>
            <a href="https://t.me/CRYPTOGCALL" target="_blank" rel="noreferrer"><TelegramIcon/></a>
          </div>
          <h1>CRYPTO G CALLs</h1>

          <div className="mobile_social_icons">
            <a href="https://t.me/CRYPTOGCALL" target="_blank" rel="noreferrer"><TwitterIcon/></a>
            <a href="https://t.me/CRYPTOGCALL" target="_blank" rel="noreferrer"><TelegramIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;